export var SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export var SKINS = {
  LIGHT: 'light',
  LIGHT_DARK: 'light-dark',
  STANDARD: 'standard',
  PREMIUM: 'premium'
};
export var PRIORITIES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INVERTED: 'inverted'
};